var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warning mb-2",on:{"click":_vm.goToDetailsDocs}},[_vm._t("title"),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }